import { render, staticRenderFns } from "./InvestorQuestion.vue?vue&type=template&id=4ad21adc&"
import script from "./InvestorQuestion.vue?vue&type=script&lang=js&"
export * from "./InvestorQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports